export default "__VITE_ASSET__356a89e6__"